import { useState } from "react";

/**
 * Discrete version chip rendered in the auth-shell footer and on the
 * profile-settings page. Hover reveals the full SHA + build date;
 * click copies the long form to the clipboard so a user reporting a
 * bug can paste an exact deploy identifier.
 *
 * The three globals are injected by Vite at build time (see
 * `vite.config.ts > define` and `src/vite-env.d.ts` for the
 * declarations).
 */
export function VersionBadge({ className = "" }: { className?: string }) {
  const [copied, setCopied] = useState(false);

  const showSha = __BUILD_SHA__ && __BUILD_SHA__ !== "dev";
  const longForm = showSha
    ? `${__APP_VERSION__}+${__BUILD_SHA__} · ${__BUILD_DATE__}`
    : `${__APP_VERSION__} · dev (${__BUILD_DATE__})`;

  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(longForm);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      /* clipboard blocked (e.g., insecure context) — silently no-op */
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      title={longForm}
      className={`text-[10px] uppercase tracking-wide text-muted/70 dark:text-muted-dark/70 hover:text-muted dark:hover:text-muted-dark transition-colors ${className}`}
      aria-label={`Version ${longForm}`}
    >
      {copied ? "copié ✓" : `v${__APP_VERSION__}`}
    </button>
  );
}
